import { motion } from 'framer-motion'
import { CheckCircle2, Award, Users } from 'lucide-react'

const Presentation = () => {
  const values = [
    { title: "Intégrité", desc: "La transparence et l'éthique au cœur de nos relations.", icon: <CheckCircle2 size={32} /> },
    { title: "Excellence", desc: "Un engagement constant vers la qualité supérieure.", icon: <Award size={32} /> },
    { title: "Proximité", desc: "Une écoute active et une présence terrain affirmée.", icon: <Users size={32} /> },
  ]

  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4 md:px-6">
        {/* Header */}
        <section className="mb-20 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-cidh-blue mb-6 font-montserrat">À Propos de CIDH Consulting</h1>
          <div className="w-24 h-1.5 bg-cidh-gold mx-auto mb-10"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Centre International pour le Développement Humain (CIDH), nous sommes un acteur majeur du conseil et de la formation en Côte d'Ivoire et en Afrique de l'Ouest depuis 2007.
          </p>
        </section>

        {/* Vision/History */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-24 items-center">
          <div>
            <h2 className="text-3xl font-bold text-cidh-blue mb-6 font-montserrat">Notre Mission</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Notre mission est d'accompagner les organisations dans la valorisation de leur capital humain et l'optimisation de leurs performances opérationnelles. Nous croyons que le développement de l'Afrique passe par des structures fortes et des compétences pointues.
            </p>
            <div className="space-y-4">
              <div className="bg-cidh-gray-light p-4 rounded-lg border-l-4 border-cidh-green">
                <p className="font-semibold text-cidh-blue">20+ ans au service du développement</p>
              </div>
              <div className="bg-cidh-gray-light p-4 rounded-lg border-l-4 border-cidh-gold">
                <p className="font-semibold text-cidh-blue">Plus de 500 cadres formés chaque année</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img src="/images/presentation-cidh.jpeg" alt="Team presentation" className="rounded-2xl shadow-2xl" />
            <div className="absolute -bottom-6 -right-6 bg-cidh-gold text-white p-8 rounded-2xl hidden md:block">
              <p className="text-4xl font-bold">100%</p>
              <p className="text-sm">Satisfaction Client</p>
            </div>
          </div>
        </div>

        {/* Values */}
        <section className="mb-24">
          <h2 className="text-3xl font-bold text-center text-cidh-blue mb-16 font-montserrat">Nos Valeurs Fondamentales</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {values.map((v, i) => (
              <div key={i} className="text-center p-8 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all">
                <div className="text-cidh-gold mb-6 flex justify-center">{v.icon}</div>
                <h3 className="text-xl font-bold mb-4 text-cidh-blue">{v.title}</h3>
                <p className="text-gray-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  )
}

export default Presentation
